// extracted by mini-css-extract-plugin
export var card = "SimpleBreedCarouselCard-module--card--a54f9";
export var cardimg = "SimpleBreedCarouselCard-module--cardimg--4ad8d";
export var cardwrapper = "SimpleBreedCarouselCard-module--cardwrapper--80947";
export var customborderprovider = "SimpleBreedCarouselCard-module--customborderprovider--9bfb5";
export var details = "SimpleBreedCarouselCard-module--details--cb4f4";
export var image = "SimpleBreedCarouselCard-module--image--c0b07";
export var text = "SimpleBreedCarouselCard-module--text--4e715";
export var title = "SimpleBreedCarouselCard-module--title--03c02 headings-module--signpostHeadingXSmall--3be29";